import React from 'react';
import useFetchData from '../../../../hooks/useFetchData';
import { GeneralOverviewPageRenderedComponentProps } from '../../../../layout/general/SimpleGeneralPageWrapper';
import GeneralComponentErrorShield from '../../../general/GeneralComponentErrorShield';
import DeceasedTable from './DeceasedTable.component';
import { createSectionByIdSelector } from '../../../../redux/pages/selectors';
import { useSelector } from 'react-redux';

const SifRaifDeceased: React.FC<GeneralOverviewPageRenderedComponentProps> = ({
  section,
  positionDate,
}) => {
  const sectionDetails = useSelector(createSectionByIdSelector(section));
  const fundTypes = sectionDetails?.fundTypes;

  const schemas = sectionDetails?.fundTypes.length
    ? `&schemas=${sectionDetails?.fundTypes}`
    : '';
  const deceasedReports = useFetchData({
    url: `reports_list?status=deceased` + schemas,
    keyName: `${fundTypes}_deceased_reports_list`,
    makeFetch: true,
  });
  const deceasedData = useFetchData({
    url: `schema_overview_monitor/${positionDate}?status=deceased` + schemas,
    keyName: `${fundTypes}_overview_data_${positionDate}_deceased`,
    makeFetch: positionDate ? true : false,
  });

  return (
    <GeneralComponentErrorShield dataObjects={[deceasedReports, deceasedData]}>
      <DeceasedTable reportsData={deceasedReports} tableData={deceasedData} />
    </GeneralComponentErrorShield>
  );
};

export default SifRaifDeceased;
